import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BusinessPublicInfo } from '../../../../shared/interfaces';

@Component({
  selector: 'app-business-profile-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './business-profile-header.html',
  styleUrl: './business-profile-header.css',
})
export class BusinessProfileHeaderComponent {
  @Input() business: BusinessPublicInfo | null = null;
  @Input() isOpen: boolean = false;
  @Input() todayHours: string | null = null;

  getGoogleMapsUrl(): string {
    const address = this.business?.address;
    if (!address) return '#';
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
  }

  getInitials(): string {
    const name = this.business?.name || '';
    return name
      .split(/\s+/)
      .slice(0, 2)
      .map((w) => w.charAt(0).toUpperCase())
      .join('');
  }

}
